<script lang="ts">
  import "../../variables.css";
</script>

<footer class="footer">
  <span>VisConfig a small learning project</span>
  <a href="https://github.com/HugoAGax/VisConfig" target="_blank">
    Visit the GitHub respository
  </a>
  <span>Made with Svelte + TypeScript</span>
</footer>

<style>
  .footer {
    padding: 4rem 1rem;
  }
  .footer span {
    display: block;
    font-size: 11px;
    text-transform: uppercase;
    color: #777;
    letter-spacing: 2px;
  }

  a {
    font-size: 14px;
    color: #4f46e5;
  }
</style>
